import React, { useEffect, useState } from "react";
import debounce from "awesome-debounce-promise";

import {
  Grid,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";

import Dialog from "../Custom/CustomDialog";
import SearchField from "../Custom/CustomSearch";
import Pagination from "../Custom/CustomPagination";
import { BlueTitle } from "../Custom/CustomText";
import { CustomButton, Edit, Delete } from "../Custom/CustomButton";

import { deleteOnboardingLogin, getOnboardingLogin } from "../../Services/onboardingLogin";
import { getKategoriOnboarding } from "../../Services/setting";
import { setSuccess, setWarning } from "../../Utils/showSnackbar";
import {regularDate, regularTime} from "../../Utils/date";
import exportXL from "../../Utils/exportXL";
import useCekHakAkses from "../../Utils/cekHakAkses";
import ModalAddPushNotification from "./ModalAddPushNotification";
import {
  getPushNotificationList,
  deletePushNotification, getPushNotificationDetail
} from "../../Services/pushNotif";


const useStyles = makeStyles((theme) => ({
  root: {
    flex: "1",
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
  },
  table: {
    marginTop: 20,
    minWidth: 650,
  },
  headerLeft: {
    borderTopLeftRadius: 10,
  },
  headerRight: {
    borderTopRightRadius: 10,
  },
}));

const debounceGetPushNotificationList = debounce(getPushNotificationList, 500);

const PushNotification = (props) => {
  const classes = useStyles();
  const cekRole = useCekHakAkses();
  
  const [listOnboarding, setListOnboarding] = useState([]);
  const [listKategoriOnboarding, setListKategoriOnboarding] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [flag, setFlag] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [isExport, setIsExport] = useState(false);
  
  const [dataDetail, setDataDetail] = useState(null);
  const [detailError, setDetailError] = useState(false);
  
  useEffect(() => {
    if (openAdd || openEdit) return;
    setIsFetching(true);
    debounceGetPushNotificationList({
      filter: {
        or: [
          {
            title: {
              like: searchTerm,
              options: 'i'
            },
          },
          {
            body: {
              like: searchTerm,
              options: 'i'
            },
          }
        ]
      },
      skip: page * rowsPerPage,
      limit: rowsPerPage,
    })
      .then((res) => {
        setListOnboarding(res.data.items);
        setTotalData(res.data.count);
        setIsFetching(false);
      })
      .catch((err) => {
        console.error(err);
        setIsFetching(false);
      });
  }, [page, rowsPerPage, searchTerm, flag, openEdit, openAdd]);
  
  
  const handleOpen = (name, data) => {
    if (name === "add") {
      setOpenAdd(true);
    } else if (name === "edit") {
      setOpenEdit(true);
    } else {
      setOpenDelete(true);
      setSelectedData(data.id);
    }
  };
  
  const getDataExport = async () => {
    let page = 0;
    let skip = 0;
    const limit = 10;
    const fetch = async () => {
      const result = await getOnboardingLogin(searchTerm, page, limit);
      exportData.splice(skip * limit, limit, ...result.data.items);
      setExportData(exportData);
    };
    if (exportData.length >= totalData) return;
    while (skip < totalData) {
      await fetch();
      page += 1;
      skip += limit;
    }
  };
  
  const getDetail = async (id) => {
    setDataDetail(null);
    setDetailError(false);
    try {
      const detailResult = await getPushNotificationDetail(id);
      setDataDetail(detailResult.data?.item);
    } catch (err) {
      setDetailError(true);
    }
  }
  
  
  
  const handleClose = (name) => () => {
    if (name === "add") {
      setOpenAdd(false);
    } else if (name === "edit") {
      setOpenEdit(false);
      setSelectedData();
    } else {
      setOpenDelete(false);
      setSelectedData();
    }
  };
  
  const handleCloseModal = (name) => () => {
    if (name === "add") {
      setOpenAdd(false);
      setFlag(flag + 1);
    } else if (name === "edit") {
      setOpenEdit(false);
      setSelectedData([]);
      setFlag(flag + 1);
    }
  };
  
  const handleChangeSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={0}>
            <Grid container item xs={12}>
              <Grid container item xs={2} alignItems="center">
                <BlueTitle>Data Push Notification</BlueTitle>
              </Grid>
              <Grid
                container
                item
                xs={10}
                alignItems="center"
                justify="flex-end"
              >
                {cekRole("pn1") ? (
                  <SearchField
                    placeholder="Cari Judul"
                    value={searchTerm}
                    onChange={handleChangeSearch}
                    disabled={isExport}
                  />
                ) : null}
                {cekRole("pn1") ? (
                  <CustomButton
                    onClick={() => setOpenAdd(true)}
                    disabled={isExport}
                  >
                    Tambah Push Notification
                  </CustomButton>
                ) : null}
              </Grid>
            </Grid>
            
            <Grid item xs={12} style={{ overflow: "auto" }}>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerLeft}>
                      Tanggal Buat
                    </TableCell>
                    <TableCell>Title Push Notif</TableCell>
                    <TableCell>Image</TableCell>
                    <TableCell>Scheduled At</TableCell>
                    <TableCell>Target</TableCell>
                    <TableCell>Topic/Token</TableCell>
                    <TableCell className={classes.headerRight} align="center">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isFetching ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : totalData === 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        Tidak Ada Data
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  listOnboarding.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{regularDate(row.createdDate)}</TableCell>
                      <TableCell>{row.title}</TableCell>
                      <TableCell> {row?.imageUrl ? <img
                        src={row?.imageUrl}
                        alt="LogoPreview"
                        style={{
                          width: '180px',
                          height: '120%',
                          objectFit: 'cover',
                        }}
                      /> : 'Image not available'}</TableCell>
                      <TableCell>{`${regularDate(row.scheduledAt)}, ${regularTime(row.scheduledAt)}`}</TableCell>
                      <TableCell>{row.targetType}</TableCell>
                      <TableCell>{row.targetType === 'condition' ? row.topics?.join(', ') : row.targetValue}</TableCell>
                      <TableCell align="center">
                        {cekRole("pn1") ? (
                          <Edit
                            onClick={async () => {
                              handleOpen("edit", row)
                              await getDetail(row.id);
                            }}
                            disabled={false}
                          />
                        ) : null}
                        {cekRole("pn1") ? (
                          <Delete
                            onClick={() => {
                              handleOpen("delete", row)
                            }}
                            disabled={isExport}
                          />
                        ) : null}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </Table>
            </Grid>
            <Pagination
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelDisplayedRows={({ from, to, count }) =>
                from + "-" + to + " dari " + count + " Data"
              }
              count={totalData}
            />
          </Paper>
        </Grid>
      </Grid>
      {openAdd && <ModalAddPushNotification mode={'add'} open={openAdd} onClose={() => {
        setOpenAdd(false);
      }}/>}
      {openEdit && !dataDetail && <Dialog open={true} handleClose={() => setOpenEdit(false)} title="Load notification" body={detailError ? "Unable to load notification. Close and try again." : "Loading notification…"} onCancel={() => setOpenEdit(false)} cancelButtonText="Close" onAccept={() => setOpenEdit(false)} acceptButtonText="Close" />}
      {openEdit && dataDetail && <ModalAddPushNotification mode={'edit'} composerData={dataDetail} open={openEdit} onClose={() => {
        setOpenEdit(false);
      }}/>}
      <Dialog
        open={openDelete}
        handleClose={handleClose("delete")}
        title="Hapus Task Push Notification"
        body="Apakah anda yakin untuk menghapus data Push Notification? Data akan hilang serta tidak dapat dikembalikan."
        onCancel={handleClose("delete")}
        cancelButtonText="Cancel"
        onAccept={() => {
          deletePushNotification(selectedData).then(() => {
            setOpenDelete(false);
            setSelectedData();
            setFlag(flag + 1);
            setSuccess("Sukses! Data berhasil dihapus");
          });
        }}
        acceptButtonText="Hapus"
      />
    </div>
  );
};

export default PushNotification;
